import "./style.scss";
import * as React from "react";
import Section from "../../../core/Section";
import Button from "../../../core/Button";
import Table from "../../../core/Table";

const FAILED_REPORT_COLUMNS = [
  {
    title: "Report Name",
    dataIndex: "name",
    key: "name",
    width: 100
  },
  {
    title: "Merchant",
    dataIndex: "merchant_name",
    key: "merchant_name",
    width: 175
  },
  {
    title: "File Name",
    dataIndex: "filename",
    key: "filename",
    width: 250
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 75
  },
  {
    title: "Error",
    dataIndex: "error",
    key: "error",
    width: 250
  },
  {
    title: "Process",
    dataIndex: "process",
    key: "process",
    width: 100
  },
  {
    //title: "Regenerate Report",
    dataIndex: "regenerate_link",
    key: "regenerate_link",
    width: 120
  },
  {
    //title: "Resend Report",
    dataIndex: "resend_link",
    key: "resend_link",
    width: 120
  }
];

class FailedReportList extends React.Component<
  IAdminModuleProps & IAdminModuleActions,
  IAdminModuleState
> {
  componentWillMount() {
    this.props.getFailedReports();
  }

  handleResend(
    merchant_id: number,
    report_id: number,
    report_file_id: number,
    process: string
  ) {
    this.props.resendReport(merchant_id, report_id, report_file_id, process);
  }

  handleRegenerate(id: number) {
    this.props.regenerateReport(id);
  }

  handleRegenerateSystemFailures() {
    this.props.regenerateSystemFailures();
  }

  mapReportsToTableRows() {
    return this.props.files.map((file: IAdminReportFile) => {
      return {
        key: `${file.filename}_${file.id}_${Math.floor(Math.random() * 3 + 1)}`,
        name: file.name,
        filename: file.filename,
        merchant_name: file.merchant,
        process: file.process,
        status: file.status,
        error: file.error,
        resend_link: (
          <Button
            type="primary"
            onClick={this.handleResend.bind(
              this,
              file.merchant_id,
              file.report_id,
              file.id,
              file.process
            )}
          >
            Resend Report
          </Button>
        ),
        regenerate_link: (
          <Button
            type="primary"
            onClick={this.handleRegenerate.bind(this, file.id)}
          >
            Regenerate Report
          </Button>
        )
      };
    });
  }

  render() {
    return (
      <div className="admin-component">
        <Section className="failed-reports">
          <h1>Failed Reports</h1>
          <Button
            type="primary"
            onClick={this.handleRegenerateSystemFailures.bind(this)}
          >
            Recover System Failures
          </Button>
          <Table
            size="middle"
            dataSource={this.mapReportsToTableRows()}
            columns={FAILED_REPORT_COLUMNS}
          />
        </Section>
      </div>
    );
  }
}

export default FailedReportList as any;



// WEBPACK FOOTER //
// ./client/modules/Admin/components/FailedReportList/component.tsx